import Overlay from 'common/components/core/Overlay'
import { PopupInterface } from 'common/types/entities/popup-interface'
import { closePopup } from 'publisher/actionsManagement'
import { PopupNew } from 'publisher/components/entities/popup-new'
import useBlog, { selectors as blogSelectors } from 'publisher/hooks/useBlog'
import { PopupWrapperUi } from 'publisher/pages/ui/popup-wrapper-ui'
import { useManagement, usePage } from 'publisher/store'
import managementSelectors from 'publisher/store/management/managementSelectors'
import pageSelectors from 'publisher/store/page/pageSelectors'
import { setCloseCookie } from 'publisher/utils/cookie'
import React from 'react'
import { useDispatch } from 'react-redux'

export const BlogTriggeredPopup = () => {
  const triggeredPopupId = useManagement(managementSelectors.getActivePopupId)
  const popup = usePage(page =>
    pageSelectors.getEntityById(page, triggeredPopupId),
  ) as PopupInterface
  // we could have global popups available on all pages and posts
  const blogLayoutPageId = useBlog(blogSelectors.getBlogLayoutPageId)
  const dispatch = useDispatch()

  if (!popup) {
    return null
  }

  const handleClose = (popupId: string, closedDays: number | undefined) => {
    setCloseCookie(blogLayoutPageId, popupId, closedDays)
    dispatch(closePopup)
  }

  return (
    <React.Fragment>
      <PopupWrapperUi>
        <PopupNew
          entity={popup}
          closePopup={() => handleClose(popup.id, popup.closedDays)}
        />
      </PopupWrapperUi>
      <Overlay dark />
    </React.Fragment>
  )
}
